import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(
  'd642dd524b0715f63a56a78b65407ebbTz0xMjUxMzIsRT0xODAxNTI2Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
);
